<template>
    <div>
        <div
            v-for="(block, blockIndex) in blocks"
            :key="block.name + blockIndex"
            :class="[classe, block.bg_color]"
            :style="style(block)"
            @click.prevent="handleClick($event, block)"
        >
            {{ block.name }}{{ !block.more ? ':' : '' }} {{ block.description }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        blocks: { type: Array, required: true },
        week: { type: Array, required: false },
        classe: { type: String, required: true }
    },
    data() {
        return {
            dayWidth: 100/7,
        }
    },
    methods: {
        style(block) {
            if(this.classe == 'modal-block') {

                return;
            }

            return { left: this.calcLeft(block), width: this.calcWidth(block), top:  this.calcTop(block)};
        },
        calcLeft(block) {
            return block.show ? (block.left  * this.dayWidth) + '%' : '-9999px';
        },
        calcWidth(block) {
            return ((block.width * this.dayWidth) - 2) + '%';
        },
        calcTop(block) {
            return block.top * (22 + 2) + 30 + 'px';//(height + gap) + top daynumber
        },
        handleClick(event, block) {
            const popupWidth = 360;
            const screenWidth = window.innerWidth;

            let rect = event.target.getBoundingClientRect();
            let top = rect.bottom + window.scrollY + 2;//gap = 2
            let leftPosition = rect.left + window.scrollX;

            if(this.classe == 'modal-block') {
                rect = document.getElementById('moreModal').getBoundingClientRect();
                top = rect.top + window.scrollY,
                leftPosition = rect.left + window.scrollX + popupWidth + 20;
            }

            if (leftPosition + popupWidth > screenWidth) {
                leftPosition = screenWidth - popupWidth - 50;

                if(this.classe == 'modal-block') {
                    leftPosition =  rect.left + window.scrollX - popupWidth - 20;
                }
            }

            this.$emit('clicked', event, {
                block: block,
                position: {
                    top: top,
                    left: leftPosition
                },
                day: block.more ? this.week[block.startDayOfWeek] : '',
            });
        }
    },
}
</script>

<style scoped>
.event-block, .modal-block {
    cursor: pointer;
    height: 22px;
    box-sizing:border-box;
    border-radius: 4px;
    padding: 0px 8px;
    font-size: 0.8rem;
    border: 1px solid transparent;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.event-block {
    position: absolute;
    margin: 0 1%;
}
.modal-block {
    margin: 0 0 6px 0;
}
.event-block.bg-white, .modal-block.bg-white {
    border: 1px solid #c0c0c0;
}
</style>